import { NoddiPhoneInput, NoddiPhoneInputProps } from '@ui-components/Inputs/NoddiPhoneInput';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = Omit<NoddiPhoneInputProps, 'name' | 'value' | 'defaultValue' | 'onChange'>;

export const TanstackFormPhoneInput = ({ label = 'Phone number', disableAutoFocus = true, onBlur, ...rest }: Props) => {
  const field = useFieldContext<string>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiPhoneInput
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        onBlur={(event) => {
          field.handleBlur();
          onBlur?.(event);
        }}
        value={field.state.value ?? ''}
        onChange={(value: string) => field.handleChange(value)}
        disableAutoFocus={disableAutoFocus}
        label={label}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
